// OverallContext.js  
import React, { createContext, useContext,useState } from 'react';  
import { use } from 'react';

export const OverallContext = createContext();  
export const useLoader=()=>useContext(OverallContext);

export const OverallProvider = ({ children }) => {  

     // function to handle click event of the first button  to enable and disable buttons
     const [isSearchButtonEnabled, setIsSearchButtonEnabled] = useState(false);
     
     const [loading, setLoading] = useState(false);


   const enableSaveSearchButton = () => {  
    isSearchButtonEnabled?  setIsSearchButtonEnabled(true):setIsSearchButtonEnabled(true);   
  }; 


    return (  
        <OverallContext.Provider value={{isSearchButtonEnabled, setIsSearchButtonEnabled, enableSaveSearchButton, loading, setLoading}}>  
{ children }
        </OverallContext.Provider>  
    );  
};